import { useQuery } from "@tanstack/react-query";
import { OmsReportsApiFactory } from "../lusca-search-api/LuscaSearchApiFactory";
import { OmsProduct, Stage } from "../lusca-search-api/generated-src";
import { useOmsIdentity } from "./omsContextIdentity";

export default function useOmsReport(product: OmsProduct, enabled = true) {
  const { namespace, financialAccount } = useOmsIdentity(product);
  return useQuery({
    queryKey: ["oms-report", namespace],
    enabled,
    staleTime: 60_000,
    refetchInterval: 60_000,
    refetchIntervalInBackground: false,
    retry: false,
    queryFn: async () =>
      (
        await (financialAccount
          ? OmsReportsApiFactory().getOmsReport(
              product,
              Stage.Prod,
              financialAccount
            )
          : OmsReportsApiFactory().getOmsReport(product, Stage.Prod))
      ).data,
  });
}
